import React, { useState, useEffect } from "react"
import _ from "lodash"
// Components
import { alphanum } from "components/table/lib/sort"
import { CheckboxInput, DropdownInput, ListboxInput, NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"
// Styles
import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { ListboxSection_s, ListboxHeaderSort_s, SelectAllCheckbox_s } from "styles/input-styles"

const TenantGroup = (props: {rowData: [], defaults: object, field: string, namedItems: object, persist: Function}) => {
  const emptyRecord = {
    areaType: null,
    cap: null,
    floor: null
  }
  const [sortDirty, setSortDirty] = useState<boolean>(false);
  const [sortAsc, setSortAsc] = useState<boolean>(true);
  const [data, setData] = useState<object|null>(props.rowData[props.field]);
  const [showSelected, setShowSelected] = useState<boolean>(false);

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field].state !== 'byTenantGroup') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)
    if (field === 'items'){
      let items = val
      items = items.map(item => { return { 'tenantGroupId': item }})
      nextData[field] = items
    } else {
      nextData[field] = val
    }
    setData(nextData);
    props.persist({...nextData, state: 'byTenantGroup'}, 'areadetail', props.rowData)
  }

  const attrs          = (field) => field_attrs('area')(field)(props.rowData, props)
  let tenantGroups     = props.namedItems['tenantGroups'];
  let tenantGroupsData = _.cloneDeep(data);
  tenantGroupsData     = tenantGroupsData && tenantGroupsData['items'] ? tenantGroupsData['items'].map(item => item.tenantGroupId) : null
  const areaTypeOptions = [{label: 'Occupied', value: 'Occupied'},{label: 'Vacant', value: 'Vacant'},{label: 'All', value: 'All'}]

  if (showSelected && tenantGroupsData){
    tenantGroups = tenantGroups.filter(tenantGroup => tenantGroupsData.includes(tenantGroup.tenantgroupid));
  }

  function selectAll():void {
    data && data['items'] && data['items'].length === tenantGroups.length ? updateData([], 'items') : updateData(tenantGroups.map(tenantGroup => tenantGroup.tenantgroupid), 'items')
  }

  if (sortDirty){
    sortAsc ? tenantGroups.sort((a, b) => alphanum(a.name, b.name)) : tenantGroups.sort((a, b) => alphanum(b.name, a.name))
  }

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Area Type</label>
          <DropdownInput className="automated" data={data} attrs={attrs} field='areaType' options={areaTypeOptions} persist={updateData} />
        </div>
        <div>
          <label>Floor</label>
          <NumberInput className="automated" data={data} attrs={attrs} field="floor" readPrecision={2} writePrecision={2} persist={updateData} />
        </div>
        <div>
          <label>Cap</label>
          <NumberInput className="automated" data={data} attrs={attrs} field="cap" readPrecision={2} writePrecision={2} persist={updateData} />
        </div>
      </SingleRowCarouselState_s>
      <SingleRowCarouselState_s style={{'marginTop': 20}}>
        <div>
          <label>Show Selected</label>
          <CheckboxInput className="automated" data={{showSelected}} field='showSelected' persist={(val, field) => setShowSelected(val)} />
        </div>
        <ListboxSection_s>
          <ListboxHeaderSort_s>
            <label>Tenant Group</label>
            <a onClick={(e) => { sortDirty === false ? setSortDirty(true) : setSortAsc(!sortAsc)}}>
              { !sortDirty && <i className="pi pi-sort-alt" style={{height: '18px', width: '18px'}} /> }
              { sortDirty && sortAsc && <i className="pi pi-sort-amount-down" style={{height: '18px', width: '18px'}} /> }
              { sortDirty && !sortAsc && <i className="pi pi-sort-amount-up" style={{height: '18px', width: '18px'}} /> }
            </a>
          </ListboxHeaderSort_s>
          <SelectAllCheckbox_s className="automated" data={{allSelected: tenantGroupsData ? tenantGroupsData.length === tenantGroups.length : false}} field='allSelected' persist={selectAll} />
          <ListboxInput
            className="automated"
            data={{"items": tenantGroupsData}}
            attrs={attrs}
            field="items"
            multiple={true}
            persist={updateData}
            options={tenantGroups.map(tenantGroup => { return {label: tenantGroup.name, value: tenantGroup.tenantgroupid}})}
          />
        </ListboxSection_s>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default TenantGroup
